import { useMemo } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { Flow } from "../../../../shared/components/Flow";
import { StepInformation } from "./StepInformation";
import { StepSubscription } from "./StepSubscription";
import { StepSuccess } from "./StepSuccess";
import { PATH_BENEFITS_ENROLL } from "../../paths";

export const RouteEnroll: React.FC<
  RouteComponentProps<
    any,
    any,
    {
      backPath?: string;
    }
  >
> = props => {
  const history = useHistory();
  const backPath = useMemo(
    () => props.location.state?.backPath || "/member/benefits",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <Flow
      title="Premium Perks enrollment"
      basePath={PATH_BENEFITS_ENROLL}
      steps={[
        {
          slug: "information",
          title: "Premium Perks enrollment",
          component: StepInformation
        },
        {
          slug: "subscription",
          title: "Premium Perks enrollment",
          component: StepSubscription
        },
        {
          slug: "success",
          title: "Premium Perks enrollment",
          component: StepSuccess
        }
      ]}
      onBack={() => {
        history.push(backPath);
      }}
      onNext={() => {
        history.push(backPath);
      }}
      hideNavigation
    />
  );
};
